import React, { Fragment, useEffect,useState } from 'react';
import { Breadcrumbs, H5, P } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import Calender from '../../Common/CommonWidgets/Calender';
import UpcomingSchedule from './UpcomingSchedule';
import Schedule from './Schedule';

export const roleId =localStorage.getItem("role_id")

const SamplePage = () => {


  console.warn(roleId)

  const [startDate, setStartDate] = useState(new Date());
  const [currentDate, setDate] = useState('');
  const handleChange = (date) => {
    console.log(date)
    setStartDate(date);
  };
  function reload(){
    window.location.reload()
  }

  const year = startDate.getFullYear();
  const month = String(startDate.getMonth() + 1).padStart(2, '0');
  const day = String(startDate.getDate()).padStart(2, '0');
  
  const fdate = `${year}-${month}-${day}`;
  useEffect(()=>{
   
    setDate(fdate)
    console.log(fdate)
    console.log(startDate)
  },[startDate])
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Dashboard' parent='Dashboard'  />
      {/* <Breadcrumbs mainTitle='Dashboard' parent='Pages' title='Dashboard' /> */}
      <Container fluid={true}>
      <Row>
      {roleId !== '4' ? 
        <Col xxl='6' xl='6' lg='6' sm='6' className='col-ed-6 box-col-5'>
            <Calender func={handleChange} cDate={startDate}/> 
          </Col>: null } 
        <Col xxl='6' xl='6' lg='6' sm='6' className='col-ed-6 box-col-5'>
            <UpcomingSchedule roleId={roleId}/>
          </Col>
          {/* <Col sm='12'>
            <Card>
              <CardHeader>
                <H5>Sample Card</H5>
                <span>lorem ipsum dolor sit amet, consectetur adipisicing elit</span>
              </CardHeader>
              <CardBody>
                <P>
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                  proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                </P>
              </CardBody>
            </Card>
          </Col> */}
        </Row>
        {roleId !== '4' ?  <Row>
          <Col>
           <Schedule date={currentDate} /> 
          </Col>
        </Row> : null}
      </Container>
    </Fragment>
  );
};

export default SamplePage;
